/**
 * Admin Security Console Page
 * Dedicated page for comprehensive security management
 */

import React from 'react';
import {
  Container,
  Box,
  Typography,
  Breadcrumbs,
  Link
} from '@mui/material';
import { NavigateNext, Security } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import AdminSecurityConsole from '../components/admin/AdminSecurityConsole';

const AdminSecurityPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs 
        separator={<NavigateNext fontSize="small" />} 
        sx={{ mb: 2 }}
      >
        <Link
          underline="hover"
          sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          color="inherit"
          onClick={() => navigate('/admin')}
        >
          Admin Dashboard
        </Link>
        <Typography
          sx={{ display: 'flex', alignItems: 'center' }}
          color="text.primary"
        >
          <Security sx={{ mr: 0.5 }} fontSize="inherit" />
          Security Console
        </Typography>
      </Breadcrumbs>

      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
          Security Management Console
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Comprehensive security management and threat monitoring
        </Typography>
      </Box>

      {/* Dashboard */}
      <AdminSecurityConsole />
    </Container>
  );
};

export default AdminSecurityPage;



